import { useRef } from "react";
import { useDatepickerContext } from "./DatepickerProvider";
import { useDay } from "@datepicker-react/hooks";
import { SizableText, Stack } from "tamagui";
import { jsx } from "react/jsx-runtime";
const getColor = (isSelected, isSelectedStartOrEnd, isWithinHoverRange, isDisabled) => ({
  selectedFirstOrLastColor,
  normalColor,
  selectedColor,
  rangeHoverColor,
  disabledColor
}) => isSelectedStartOrEnd ? selectedFirstOrLastColor : isSelected ? selectedColor : isWithinHoverRange ? rangeHoverColor : isDisabled ? disabledColor : normalColor;
function LmDay({ dayLabel, date }) {
  const dayRef = useRef(null), datepickerContext = useDatepickerContext(), {
    isSelected,
    isSelectedStartOrEnd,
    isWithinHoverRange,
    disabledDate,
    onClick,
    onMouseEnter
  } = useDay({
    date,
    dayRef,
    ...datepickerContext
  });
  if (!dayLabel)
    return /* @__PURE__ */ jsx(Stack, { display: "flex", flex: 1 });
  const getColorFn = getColor(isSelected, isSelectedStartOrEnd, isWithinHoverRange, disabledDate);
  return /* @__PURE__ */ jsx(
    SizableText,
    {
      ref: dayRef,
      onPress: onClick,
      onHoverIn: onMouseEnter,
      disabled: disabledDate,
      width: `${100 / 7}%`,
      textAlign: "center",
      paddingVertical: "$2",
      cursor: "pointer",
      backgroundColor: getColorFn({
        selectedFirstOrLastColor: "$blue7",
        normalColor: "$background",
        selectedColor: "$blue5",
        rangeHoverColor: "$blue6",
        disabledColor: "#FFFFFF"
      }),
      children: dayLabel
    }
  );
}
export {
  LmDay
};
//# sourceMappingURL=LmDay.js.map
